import api from './api';
import type { Invoice, InvoiceStatus } from '../types/venue';

const base = (venueId: string) => `/admin/venue/${venueId}/invoices`;

const invoiceService = {
  createInvoice: async (
    venueId: string,
    data: {
      supplierId: string;
      invoiceNumber: string;
      purchaseOrderId?: string;
      invoiceDate?: string;
      dueDate?: string;
      totalAmount?: number;
      notes?: string;
    },
  ): Promise<Invoice> => {
    const response = await api.post(base(venueId), data);
    return response.data;
  },

  updateInvoice: async (
    venueId: string,
    invoiceId: string,
    data: {
      invoiceNumber?: string;
      supplierId?: string;
      invoiceDate?: string | null;
      dueDate?: string | null;
      totalAmount?: number | null;
      notes?: string;
      status?: InvoiceStatus;
    },
  ): Promise<Invoice> => {
    const response = await api.patch(`${base(venueId)}/${invoiceId}`, data);
    return response.data;
  },

  uploadAttachment: async (
    venueId: string,
    invoiceId: string,
    file: File,
  ): Promise<Invoice> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post(
      `${base(venueId)}/${invoiceId}/attachments/upload`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    return response.data;
  },

  deleteAttachment: async (
    venueId: string,
    invoiceId: string,
    storageKey: string,
  ): Promise<Invoice> => {
    const response = await api.delete(`${base(venueId)}/${invoiceId}/attachments`, {
      data: { storageKey },
    });
    return response.data;
  },

  getAttachmentUrl: (venueId: string, invoiceId: string, attachmentId: string): string => {
    return `${base(venueId)}/${invoiceId}/attachments/${attachmentId}/file`;
  },
};

export default invoiceService;
